function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { Action } from '../Action';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-1k2r6x0-0"
})(["display:flex;flex-direction:row;align-items:end;flex-grow:0;width:max-content;gap:var(--aui-spacing-050);"]);
export const StyledReviews = styled.div.withConfig({
  componentId: "aui__sc-1k2r6x0-1"
})(["font-size:14px;line-height:16px;margin-left:var(--aui-spacing-050);color:var(--aui-on-surface-soft);", ""], ({
  $isInteractive
}) => $isInteractive ? 'cursor: pointer' : 'text-decoration: none;');
export const Reviews = props => /*#__PURE__*/React.createElement(StyledReviews, _extends({
  $isInteractive: !!props.onClick || !!props.href,
  as: props.onClick || props.href ? Action.Inline : undefined
}, props));